import {
  Flex,
  FormControl,
  FormErrorMessage,
  forwardRef,
  Input,
} from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import { Patient } from "../../types/patient.types";
import { format } from "date-fns";
import { useImperativeHandle } from "react";

type PatientFormProps = {
  value?: Patient;
};

export type PatientFormHandler = {
  valid: () => Promise<boolean>;
  values: () => Patient;
  reset: () => void;
};

const PatientForm = forwardRef(({ value }: PatientFormProps, ref) => {
  const methods = useForm();

  useImperativeHandle(ref, () => ({
    valid: async () => {
      return methods.trigger();
    },
    values: () => {
      return methods.getValues();
    },
    reset: () => {
      methods.setValue("firstName", "")
      methods.setValue("lastName", "")
      methods.setValue("birthDate", undefined)
    },
  }));
  return (
    <FormProvider {...methods}>
      <form style={{ marginTop: "32px", marginBottom: "32px" }}>
        <Flex direction="column" gap="24px">
          <FormControl isInvalid={!!methods.formState.errors.firstName}>
            <Input
              id="firstName"
              placeholder="Prénom"
              defaultValue={value ? value.firstName : undefined}
              tabIndex={1}
              {...methods.register("firstName", {
                required: "Ce champ est obligatoire",
              })}
            ></Input>
            <FormErrorMessage>
              <>{methods.formState.errors?.firstName?.message}</>
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={!!methods.formState.errors.lastName}>
            <Input
              id="lastName"
              placeholder="Nom"
              defaultValue={value ? value.lastName : undefined}
              tabIndex={1}
              {...methods.register("lastName", {
                required: "Ce champ est obligatoire",
              })}
            ></Input>
            <FormErrorMessage>
              <>{methods.formState.errors?.lastName?.message}</>
            </FormErrorMessage>
          </FormControl>

          <FormControl isInvalid={!!methods.formState.errors.birthDate}>
            <Input
              id="birthDate"
              placeholder="Date de naissance"
              type="date"
              defaultValue={
                value?.birthDate
                  ? format(value.birthDate, "yyyy-MM-dd")
                  : undefined
              }
              tabIndex={1}
              {...methods.register("birthDate", {
                required: "Ce champ est obligatoire",
              })}
            ></Input>
            <FormErrorMessage>
              <>{methods.formState.errors?.birthDate?.message}</>
            </FormErrorMessage>
          </FormControl>
        </Flex>
      </form>
    </FormProvider>
  );
});

export default PatientForm;
